module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/logo/logo-full-130.png"+" 130w",
        images: [{path: __webpack_public_path__ + "assets/images/logo/logo-full-130.png",width: 130,height: 46}],
        src: __webpack_public_path__ + "assets/images/logo/logo-full-130.png",
        toString: function(){return __webpack_public_path__ + "assets/images/logo/logo-full-130.png"},
        
        width: 130,
        height: 46
      }